import React from 'react';
import { Profile } from '../../api/types/profile';
import { ProjectErrorType } from '../../utils/errors/types';

export interface SessionContextType {
  currentProfile: Profile | undefined;
  isLoggedIn: boolean;
  login: (email: string, password: string) => Promise<ProjectErrorType | undefined>;
  recoverPassword: (email: string) => Promise<void>;
  refreshProfile: () => Promise<void>;
  logout: () => void;
}

export const SessionContext = React.createContext<SessionContextType>({
  currentProfile: undefined,
  isLoggedIn: false,
  login: async () => {
    return undefined;
  },
  recoverPassword: async () => {},
  refreshProfile: async () => {},
  logout: () => {},
});
